import { render, staticRenderFns } from "./ImageField.vue?vue&type=template&id=597180cc"
import script from "./ImageField.vue?vue&type=script&lang=ts"
export * from "./ImageField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports